export default "__VITE_ASSET__737995fc__"